"use strict";

var LoggerInstance = require("js-logger").get("ShipToActions");

var BillingAddressHelper = require("../accountComponents/BillingAddressHelper");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var ShipToStore = require("../stores/ShipToStore");

var ShipToActions = {
	initializeStore: function (options) {
		var action = Object.assign({}, options, { actionType: Constants.SHIPTO_INITIALIZE });
		Dispatcher.dispatch(action);
	},

	toggleShipToSelector: function (event) {
		if (!event || !event.target || event.type !== "change") {
			return false;
		}

		if (!ShipToStore.get("isDesignMode")) {
			event.preventDefault();
			event.stopPropagation();
		}

		var $target = $(event.target);
		var value = $target.val();

		if (value === ShipToStore.get("prevSelectorValue")) {
			return false;
		}

		var $shipTo = $target.parents("[data-component='shipTo']").first();
		var $createGiftAccountForm = $shipTo.find("[data-component='createGiftAccountForm']");
		var $otherAddresses = $shipTo.find("[data-component='shipToOtherAddresses']");

		switch (value) {
			case "primary":
				$createGiftAccountForm.addClass("hidden");
				$otherAddresses.addClass("hidden");
				BillingAddressHelper.removeNewShippingAddressOptionFromSelector();
				Dispatcher.dispatch({
					actionType: Constants.SHIPTO_SET_SELECTOR,
					selectorValue: value
				});
				break;
			case "other":
				$createGiftAccountForm.addClass("hidden");
				$otherAddresses.removeClass("hidden");
				BillingAddressHelper.handleShowOtherAddresses($otherAddresses);
				Dispatcher.dispatch({
					actionType: Constants.SHIPTO_SET_SELECTOR,
					selectorValue: value
				});
				break;
			case "gift":
				$otherAddresses.addClass("hidden");
				$createGiftAccountForm.removeClass("hidden");
				BillingAddressHelper.removeNewShippingAddressOptionFromSelector();
				Dispatcher.dispatch({
					actionType: Constants.SHIPTO_SET_SELECTOR,
					selectorValue: value
				});
				break;
			default:
				LoggerInstance.error(`${value} is not a valid ship-to address type.`);
				break;
		}
	}
};

module.exports = ShipToActions;


// WEBPACK FOOTER //
// ./Javascript/actions/ShipToActions.jsx